import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";
import { NotificationCategoryModel, NotificationConfigModel, NotificationSubCategoryModel } from "src/app/models/notification.model";
import { DataService } from "src/app/services/data/data.service";

@Component({
  selector: "notification-updater",
  templateUrl: "./notification-updater.component.html",
  styleUrls: ["./notification-updater.component.scss"]
})
export class NotificationUpdaterComponent implements OnInit {
  @Input()
  name: string;

  @Input()
  notificationConfig: NotificationConfigModel;

  @Input()
  type: string;

  constructor(
    private dataService:DataService
  ) {}

  ngOnInit() {}

  onClick(category:NotificationCategoryModel, subCategory:NotificationSubCategoryModel, channel:string, status) {
    console.log(this.notificationConfig, status);
    this.dataService.updateUserNotification(
      this.notificationConfig.uid,
      category.type,
      category.key,
      subCategory.type,
      subCategory.key,
      channel,
      subCategory.action,
      status
    );
  }
}
